export default __webpack_public_path__ + "static/media/Kristin.54e44344.jpg";